export const NotFound = ({
  message
}: {
  message: string
})=>{
  return <div>
    {message}
  </div>
}